import React, { useMemo } from "react";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import ChoosePerson, {
  ChoosePersonOptionType,
} from "../shared/components/choose-person";
import SectionFullWidthContainer from "../../ui/layout/page/forms-container/section-full-width-container";
import { useMessageSource } from "react-message-source";
import { NaturalPersonDocument } from "../../api/commercial/generated-types";
import { COMPANY_AS_SELECTION } from "./types";

interface CardsAndPinRecipient {
  authorizedRepresentatives: NaturalPersonDocument[];
}

const COMPANY_OPTION: ChoosePersonOptionType = {
  id: "cardsAndPinRecipientCompany",
  value: COMPANY_AS_SELECTION,
  messageKey: "CompanyOnline-cards-and-pin-recipient.radio-company",
};

export const CardsAndPinRecipient: React.FC<CardsAndPinRecipient> = ({
  authorizedRepresentatives,
}: CardsAndPinRecipient) => {
  const { getMessage } = useMessageSource();

  const availableOptions: ChoosePersonOptionType[] = useMemo(
    () => [
      COMPANY_OPTION,
      ...authorizedRepresentatives.map((representative) => ({
        id: `cardsAndPinRecipient-${representative.emailBusiness}`,
        value: representative.emailBusiness,
        messageKey: `${representative.firstName} ${representative.lastName}`,
      })),
    ],
    [authorizedRepresentatives],
  );

  return (
    <SectionFullWidthContainer>
      <RadioButtonContainer>
        <ChoosePerson
          title={getMessage(
            "CompanyOnline-statement-cards-and-pin-delivery.radio-two",
          )}
          id="selectedCardsAndPinRecipient"
          name="selectedCardsAndPinRecipient"
          values={availableOptions}
        />
      </RadioButtonContainer>
    </SectionFullWidthContainer>
  );
};
